module.exports = __webpack_public_path__ + "img/pocketbook-faq-panel.7127235.jpg";